import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import OptionsModal from "./options_modal";
import SelectedOptions from "./selected_options";
import Button from "./button";
import Checkbox from "./checkbox";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  ${(props) =>
    props.hasOptions
      ? `border-left: 4px solid #008a16; border-left: 4px solid var(--se-primary, #008a16);`
      : "border-left: 4px solid #9FA0A4;"}
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 0px 4px 4px 0px;
  margin-bottom: 10px;
`;

const PresentationAndArrowWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ItemPresentationWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
`;

const ModuleInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const DescriptionWrapper = styled.div`
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  overflow-x: hidden;
`;

const Description = styled.span`
  display: flex;
  flex: 1 0 calc(50% - 20px);
  font-weight: 400;
  font-size: 16px;
  color: #494b50;
  margin-right: 30px;
  margin-top: 5px;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
`;

const LinkWrapper = styled.div`
  display: inline-flex;
  font-weight: 700;
`;

const AddItemWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    display: none;
  }
`;

const SlotAndAddWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
`;

const SlotLabel = styled.span`
`;

const SlotWrapper = styled.div`
  display: flex;
`;

const SlotRow = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.color ? props.color : '#42B4E6'};
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  padding: 0px 16px;

  border-radius: 2px;
  border: 1px solid ${props => props.color ? props.color : '#42B4E6'};

  :hover {
    ${SlotLabel} {
      text-decoration: underline;
    }
  }
`;

const SlotIconWrapper = styled.div`
  margin-right: 5px;
  width: 24px;
  height: 24px;
`;

const MobileAddOptionsWrapper = styled.div`
  display: none;
  flex: 1 1 0px;
  justify-content: flex-end;

  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
      display: flex;
    }
`;

const MobileAddOptions = styled.div`
  cursor: pointer;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  color: ${props => props.color || '#42B4E6'};
  ${props => props.disabled ? 'opacity: 0.5; pointer-events: none;' : ''}
`;

const CheckboxWrapper = styled.div`
  margin-right: 10px;
`;

class Module extends React.Component {
  static propTypes = {
    module: PropTypes.object,
    isSaving: PropTypes.bool,
    renderProductLink: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryTextColor: PropTypes.string,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func,
    categoryName: PropTypes.string,
    canAddOptions: PropTypes.bool,
    bulkAccessorize: PropTypes.bool,
    modulesForBulk: PropTypes.array,
    onToggleModuleForBulk: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      defaultModalActiveCategoryType: null,
      defaultModalAccessoryToView: null,
      defaultOptionTypes: null,
      showOptions: false,
      statusToFilter: null,
      disablePreviousOnEdit: false
    };
  }

  /**
   * Checks if any of the modules have an option selected.
   *
   * @returns true if any of the modules have an option selected, false otherwise
   */
  hasSelectedOptions = () => {
    let result = false;

    const mod = this.props.module;

    if (mod.selectedOptions && ((mod.selectedOptions?.accessories || []).length > 0 || (mod.selectedOptions?.services || []).length > 0)) {
      result = true;
    }

    return result;
  }

  render = () => {
    const moduleIdentificationKey = this.props.module?.deviceIdentification?.identificationKey;
    return (
      <>
        <Container
          hasOptions={this.hasSelectedOptions()}
        >
          <PresentationAndArrowWrapper>
            {!this.props.bulkAccessorize && <CheckboxWrapper><Checkbox color={this.props.secondaryColor} textColor={this.props.secondaryTextColor} onChange={(event) => { event.preventDefault(); this.props.onToggleModuleForBulk(moduleIdentificationKey, !this.props.modulesForBulk.includes(moduleIdentificationKey)); }} checked={this.props.modulesForBulk.includes(moduleIdentificationKey)}></Checkbox></CheckboxWrapper>}
            <ItemPresentationWrapper>
              <ModuleInformationWrapper>
                <LinkWrapper>
                  {this.props.renderProductLink(this.props.module.id)}
                </LinkWrapper>
                <DescriptionWrapper>
                  <Description mobileBreakpoint={this.props.mobileBreakpoint}>{this.props.module.description}</Description>
                </DescriptionWrapper>
                <SlotAndAddWrapper>
                  {this.props.module.location && <SlotWrapper>
                    <SlotRow color={this.props.primaryColor} onClick={() => {
                      if (this.props.module.location?.onClick) {
                        this.props.module.location.onClick();
                      }
                    }}>
                      <SlotIconWrapper>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M511 897c7 0 14-3 20-7l6-7c45-73 90-146 134-220l28-45c39-61 78-124 86-190v-52c-12-140-132-246-273-247-142-3-262 106-274 249v53c8 63 47 126 85 188 10 15 19 29 27 44 39 65 79 130 120 195l16 27c6 8 15 12 25 12zm-3-725h4c117-3 220 90 230 206l1 47c-7 54-44 113-80 170-10 15-19 31-29 46-40 68-82 136-123 203l-5-8c-40-65-81-130-119-195-9-15-18-30-28-45-35-57-72-117-79-168v-48c11-117 110-208 228-208zm4 344c68 0 122-55 122-123s-55-122-122-122h-1c-68 0-123 55-122 123 0 68 55 122 123 122zm0-203c44 0 80 36 80 81 0 44-36 80-80 80s-80-36-81-80c0-44 36-80 80-81h1z"/></svg>
                      </SlotIconWrapper>
                      <SlotLabel>{this.props.module.location?.label}</SlotLabel>
                    </SlotRow>
                  </SlotWrapper>}
                  {this.props.canAddOptions && <MobileAddOptionsWrapper mobileBreakpoint={this.props.mobileBreakpoint}><MobileAddOptions color={this.props.primaryColor} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: null, defaultModalAccessoryToView: null, defaultOptionTypes: null, disablePreviousOnEdit: false });}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                      <path fill="currentColor" d="M783.5,240.6c-149.9-149.9-393.2-149.9-543-0.1c-150.1,150.1-149.8,393.1,0.1,543s392.9,150.1,542.9,0  C933.3,633.7,933.5,390.6,783.5,240.6z M511.9,742c-19,0-34.5-15.4-34.5-34.4c0,0,0-0.1,0-0.1v-161l-160.9,0.1  c-19.1,0-34.6-15.5-34.6-34.5c0.1-19.1,15.5-34.5,34.6-34.6h160.9V316.5c0.3-19.1,16.1-34.3,35.2-34c18.6,0.3,33.7,15.4,34,34v160.9  h160.9c19.1,0,34.6,15.5,34.6,34.6c0,19.1-15.5,34.6-34.6,34.6H546.6v160.9c0.1,19-15.3,34.5-34.3,34.6C512.2,742,512,742,511.9,742  z"/>
                    </svg>
                  </MobileAddOptions></MobileAddOptionsWrapper>}
                </SlotAndAddWrapper>

              </ModuleInformationWrapper>
              {this.props.canAddOptions && <AddItemWrapper mobileBreakpoint={this.props.mobileBreakpoint}>
                <Button id={`${moduleIdentificationKey}-add-options`}  icon={'plus-large'} disabled={this.props.isSaving} onClick={(event) => { event.stopPropagation(); this.setState({ modalOpen: true, defaultModalActiveCategoryType: null, defaultModalAccessoryToView: null, defaultOptionTypes: null, disablePreviousOnEdit: false });}} label={this.props.getLabel('options_screen.add_options')}></Button>
              </AddItemWrapper>}
            </ItemPresentationWrapper>

          </PresentationAndArrowWrapper>
          <SelectedOptions
            renderProductLink={this.props.renderProductLink}
            primaryColor={this.props.primaryColor}
            primaryTextColor={this.props.primaryTextColor}
            secondaryColor={this.props.secondaryColor}
            secondaryTextColor={this.props.secondaryTextColor}
            isSaving={this.props.isSaving}
            getLabel={this.props.getLabel}
            moduleItem={this.props.module}
            onAddMore={(optionCategory) => {
              this.setState({modalOpen: true, defaultModalActiveCategoryType: optionCategory, defaultModalAccessoryToView: null, defaultOptionTypes: null, disablePreviousOnEdit: false });
            }}
            onViewAccessory={(optionItem, optionCategory, statusToFilter, disablePreviousOnEdit) => {
              this.setState({modalOpen: true, defaultModalActiveCategoryType: optionCategory, defaultModalAccessoryToView: optionItem, defaultOptionTypes: optionItem.optionTypes, statusToFilter, disablePreviousOnEdit});
            }}
          >
          </SelectedOptions>
        </Container>
        {this.state.modalOpen && (
          <OptionsModal
            getLabel={this.props.getLabel}
            getAndReplaceLabel={this.props.getAndReplaceLabel}
            titleType={this.props.categoryName}
            moduleId={this.props.module.id}
            mobileBreakpoint={this.props.mobileBreakpoint}
            getOptions={() => {
              return this.props.module.getOptions();
            }}
            imageUrl={this.props.module.imageUrl}
            primaryColor={this.props.primaryColor}
            primaryTextColor={this.props.primaryTextColor}
            secondaryColor={this.props.secondaryColor}
            secondaryTextColor={this.props.secondaryTextColor}
            closeModal={() => {
              this.setState({ modalOpen: false, defaultModalActiveCategoryType: null, defaultModalAccessoryToView: null, defaultOptionTypes: null, disablePreviousOnEdit: false });
            }}
            renderProductLink={this.props.renderProductLink}
            onAddOptions={this.props.module.onAddOptions}
            onDecreaseOptions={this.props.module.onDecreaseOptions}
            onRemoveOptions={this.props.module.onRemoveOptions}
            onAddSubAccessories={this.props.module.onAddSubAccessories}
            onDecreaseSubAccessories={this.props.module.onDecreaseSubAccessories}
            onRemoveSubAccessories={this.props.module.onRemoveSubAccessories}
            deviceIdentification={this.props.module.deviceIdentification}
            isSaving={this.props.isSaving}
            defaultActiveCategoryType={this.state.defaultModalActiveCategoryType}
            defaultModalAccessoryToView={this.state.defaultModalAccessoryToView}
            defaultOptionTypes={this.state.defaultOptionTypes}
            statusToFilter={this.state.statusToFilter}
            disablePreviousOnEdit={this.state.disablePreviousOnEdit}
          ></OptionsModal>
        )}
      </>
    );
  };
}

export default Module;
